export interface WeChatSign {
  appId: string;
  timestamp: number;
  nonceStr: string;
  signature: string;
  jsapi_ticket: string;
  url: string;
}

export interface NosToken {
  token: string;
  bucket: string;
  objectName: string;
  expireAt: number;
}

export interface YXSign {
  appKey: string;
  nonce: string;
  curTime: string;
  checkSum: string;
  presetId: number;
  callbackUrl: string;
  contentId: number;
}

export enum SHARE_TYPE {
  FRIEND = 0,
  TIMELINE,
}

export enum FILE_TYPE {
  DEFAULT,
  CORRECTION_UPLOAD,
}

export interface UserGroupInfo {
  id: number;
  groupName: string;
  condition: string;
}
